import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

export default function ContactForm() {
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    emailjs.sendForm(
      'service_pdl211w',         // ✅ Your Service ID
      'template_ci2mf2r',        // ✅ Your Template ID
      e.target,
      'GI_pP7grUjHXCAatB'        // ✅ Your Public Key
    ).then(() => {
      setStatus('✅ Message sent!');
      e.target.reset();
    }).catch((err) => {
      console.error(err);
      setStatus('❌ Something went wrong. Please try again.');
    });
  };

  const currentTime = new Date().toLocaleString();

  return (
    <div className="contact-container">
      <h1>Suggestions / Contact</h1>
      <p>Got an idea or feedback? Drop it here:</p>
      <form onSubmit={sendEmail} className="contact-form">
        <input type="text" name="name" placeholder="Your name" required />
        <input type="email" name="email" placeholder="Your email" required />
        <textarea name="message" placeholder="Your message..." required />
        <input type="hidden" name="time" value={currentTime} />
        <button type="submit">Send Message</button>
        <p className="status">{status}</p>
      </form>
    </div>
  );
}
